import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Box } from "@mui/material"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { LabelCountry } from "@components"
import { WEBBACK_V2_API } from "@constants"
import { country, retailer } from "@signals"


export default function CommonFiltersSite({filters={}, ...props}) {
    const optionRetailer = useSignal([])
    const inputValue = useSignal("")

    return <AutocompleteAjaxSeeker
        multiple
        urlAjax={`${WEBBACK_V2_API}/master-data/site/options`}
        filters={{ country: country.value, ...filters }}
        label="Retailers"
        placeholder="All Retailers"
        options={optionRetailer.value}
        value={retailer.value}
        filterOptions={(options, { inputValue }) => options.filter(op => {
            if (op.value === "select_all") return true
            return op.label.toLowerCase().includes(inputValue.toLowerCase())
        })}
        onInputChange={(_, newInputValue) => {
            if (newInputValue.length)
                inputValue.value = newInputValue
        }}
        onChange={e => {
            if (props.multiple !== false && e.target.value.includes("select_all")) {
                retailer.value = [...retailer.value, ...optionRetailer.value.filter(op => op.value !== "select_all")
                    .filter(op => op.label.toLowerCase().includes(inputValue.value.toLowerCase()))
                    .map(op => op.value)
                ]
            } else {
                retailer.value = e.target.value
            }
            inputValue.value = ""
        }}
        formatOptionLabel={({ label, country, value }) => {
            if (value === "select_all")
                return <Box borderBottom="1px solid" width={1}>
                    {label}
                </Box>
            return <LabelCountry country={country} label={label} />
        }}
        onFinishAjax={options => {
            optionRetailer.value = [
                ...props.multiple !== false ? [{label: "Select All", value: "select_all"}] : [],
                ...options
            ]
        }}
        {...props}
    />
}